<footer class="footer border-top text-muted py-3">
    <div class="container text-center">
      <div>&copy; 2020-2024 - ThorDraco</div>
      <div>v{{currentApplicationVersion}}</div>
    </div>
  </footer>
  